import { MakeCall } from 'ha/services/apiV2/createMakeCall';

// eslint-disable-next-line sort-imports
import { APIV2_URL } from './constants';
import { UserDocument } from './types/UserDocument';

export type ConfirmUserDocumentUploadPayload = (
  userId: 'me' | number,
  docUUID: string,
  data: {
    title?: string;
    filename: string;
  },
) => Promise<{ data: UserDocument }>;

export default (makeCall: MakeCall): ConfirmUserDocumentUploadPayload =>
  (userId, docUUID, data) =>
    makeCall<UserDocument>(
      'PUT',
      `${APIV2_URL}/user/${userId}/document/${docUUID}/confirm`,
      {
        data,
      },
    );
